import { Restaurant } from '@/shared/model/restaurant.model';
import { IRestaurantStore } from './types';

export const state: IRestaurantStore = {
  restaurant: new Restaurant(),
  tab: 'dashboard',
  drawer: false,
  provideNow: false,
  notFound: null,
  pause: false,
  orders: [],
  workingTimes: [],
  preparingOrdersNumber: 0,
};
